import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getBrands } from "../api/brands/getBrands";

// Returns the brand roster for the brand filter on the system pages. Prefers the
// brands already in Redux (s.user.brands); if that store is empty — common when
// a system page is the entry point and AllPostsPage never ran — it fetches
// `/brands` once as a self-sufficient fallback. Tolerates both response shapes
// ({ brands: [...] } or a bare array), mirroring AllPostsPage.
export default function useBrandList() {
  const brandsRedux = useSelector((s) => s.user.brands);
  const [brandsLocal, setBrandsLocal] = useState([]);

  useEffect(() => {
    if (brandsRedux && brandsRedux.length) return undefined;
    let cancelled = false;
    getBrands()
      .then((d) => {
        if (!cancelled) setBrandsLocal((d && d.brands) || d || []);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [brandsRedux]);

  return brandsRedux && brandsRedux.length ? brandsRedux : brandsLocal;
}
